import * as React from 'react';
import { Accept } from 'react-dropzone';
import { Form } from '@/core/form/Form';
import { Text } from '@/components/atoms/Text';
import { DropzoneContainer } from '@/pages/MenuList/components/MenuModal/CreateMenuModal/ImportMenuStep/ImportMenuStep.style';
import { FileInput } from '@/components/form/FileInput';
import { SvyButton } from '@/components/savory/SvyButton';
import { FormattedMessage, useIntl } from 'react-intl';
import { safeMutate } from '@/utils/errors';
import { useTransformGuestFileMutation } from '@/services/innovorder/adminTools/adminTools.endpoints';
import { TransformGuestFileRequest, FileFormat } from '@/services/innovorder/adminTools/adminTools.type';
import { computeText } from '@/locales/utils';
import Select from '@/components/atoms/Select';
import { Controller } from 'react-hook-form';
import { FormControl, FormControls, SuccessMessage } from '../AdminTools.style';

const ALLOWED_FILE_TYPES: Accept = {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'application/vnd.ms-excel': ['.xls'],
};

const TransformGuestFile: React.FunctionComponent = () => {
    const intl = useIntl();

    const getSelectFileFormatOptions = () => {
        return Object.values(FileFormat).map((fileFormat) => ({
            label: `brand.adminTools.transformGuestFile.fileFormat.${fileFormat}`,
            value: fileFormat,
        }));
    };

    const [transformGuestFile, { isLoading, isSuccess, data }] = useTransformGuestFileMutation();

    const handleSubmitForm = async (inputs: TransformGuestFileRequest) => {
        await safeMutate(transformGuestFile(inputs));
    };
    return (
        <Form<TransformGuestFileRequest>>
            {({ handleSubmit, control }) => {
                return (
                    <>
                        <Text type="large" text="brand.adminTools.transformGuestFile.title" />

                        <FormControls>
                            <Controller
                                control={control}
                                name="fileFormat"
                                defaultValue={FileFormat.JES}
                                rules={{ required: computeText(intl, 'field.required') }}
                                render={({ field: { onChange, onBlur, value } }) => (
                                    <Select<FileFormat>
                                        value={value}
                                        options={getSelectFileFormatOptions()}
                                        onChange={onChange}
                                        labelId="brand.adminTools.transformGuestFile.fileFormat"
                                        onBlur={onBlur}
                                        placeholder="brand.adminTools.transformGuestFile.fileFormat"
                                        isTouched
                                    />
                                )}
                            />
                            <FormControl>
                                <DropzoneContainer>
                                    <React.Suspense>
                                        <FileInput
                                            mode="compact"
                                            accept={ALLOWED_FILE_TYPES}
                                            name="file"
                                            transform={{
                                                output: (file) => file[0],
                                                input: (file: File) => (file ? [file] : []),
                                            }}
                                        />
                                    </React.Suspense>
                                </DropzoneContainer>
                            </FormControl>
                            <SvyButton isLoading={isLoading} onClick={handleSubmit(handleSubmitForm)}>
                                <FormattedMessage id="button.validate" />
                            </SvyButton>
                            {isSuccess && (
                                <span>
                                    <SuccessMessage text="brand.adminTools.transformGuestFile.form.success" />
                                    {data && (
                                        <a href={data.url}>
                                            <FormattedMessage id="brand.adminTools.transformGuestFile.form.url" />
                                        </a>
                                    )}
                                </span>
                            )}
                        </FormControls>
                    </>
                );
            }}
        </Form>
    );
};
export default TransformGuestFile;
